import { DefaultGraphicsFactory } from "../factories/DefaultGraphicsFactory";
var ImageUtils = (function () {
    function ImageUtils() {
    }
    /**
     *
     */
    ImageUtils.imageToBitmapImage2D = function (img, powerOfTwo, factory) {
        if (powerOfTwo === void 0) { powerOfTwo = true; }
        if (factory === void 0) { factory = null; }
        if (!factory)
            factory = new DefaultGraphicsFactory();
        var image2D = factory.createImage2D(img.naturalWidth, img.naturalHeight, true, null, powerOfTwo);
        image2D.draw(img);
        return image2D;
    };
    ImageUtils.isImage2DValid = function (image2D) {
        if (image2D == null)
            return true;
        return ImageUtils.isDimensionValid(image2D.width, image2D.powerOfTwo) && ImageUtils.isDimensionValid(image2D.height, image2D.powerOfTwo);
    };
    ImageUtils.isHTMLImageElementValid = function (image) {
        if (image == null)
            return true;
        return ImageUtils.isDimensionValid(image.width) && ImageUtils.isDimensionValid(image.height);
    };
    ImageUtils.isDimensionValid = function (d, powerOfTwo) {
        if (powerOfTwo === void 0) { powerOfTwo = true; }
        return d >= 1 && d <= ImageUtils.MAX_SIZE && (!powerOfTwo || ImageUtils.isPowerOfTwo(d));
    };
    ImageUtils.isPowerOfTwo = function (value) {
        return value ? ((value & -value) == value) : false;
    };
    ImageUtils.getBestPowerOf2 = function (value) {
        var p = 1;
        while (p < value)
            p <<= 1;
        if (p > ImageUtils.MAX_SIZE)
            p = ImageUtils.MAX_SIZE;
        return p;
    };
    return ImageUtils;
}());
export { ImageUtils };
ImageUtils.MAX_SIZE = 8192;
export default ImageUtils;



// WEBPACK FOOTER //
// ../dist/lib/utils/ImageUtils.js